import { api } from "@/lib/apiClient";
import type {
  WorkerGroup,
  WorkerGroupDetail,
  WorkerGroupListParams,
  WorkerGroupMemberAddIn,
  WorkerGroupStatusIn,
  WorkerGroupUpsertIn,
} from "@/types/gro";

export async function listWorkerGroups(params: WorkerGroupListParams = {}) {
  const {
    include_inactive = false,
    q = "",
    group_type = "",
  } = params;

  return api.get<WorkerGroup[]>("/worker-groups", {
    params: {
      include_inactive,
      q,
      group_type: group_type || undefined,
    },
  });
}

export async function getWorkerGroup(id: string) {
  return api.get<WorkerGroupDetail>(`/worker-groups/${id}`);
}

export async function createWorkerGroup(payload: WorkerGroupUpsertIn) {
  return api.post<WorkerGroupDetail>("/worker-groups", payload);
}

export async function updateWorkerGroup(id: string, payload: WorkerGroupUpsertIn) {
  return api.put<WorkerGroupDetail>(`/worker-groups/${id}`, payload);
}

export async function setWorkerGroupStatus(id: string, payload: WorkerGroupStatusIn) {
  return api.patch<WorkerGroupDetail>(`/worker-groups/${id}/status`, payload);
}

export async function addWorkerGroupMembers(
  id: string,
  payload: WorkerGroupMemberAddIn,
) {
  return api.post<WorkerGroupDetail>(`/worker-groups/${id}/members`, payload);
}

export async function removeWorkerGroupMember(id: string, userId: string) {
  return api.delete<WorkerGroupDetail>(`/worker-groups/${id}/members/${userId}`);
}

export async function refreshWorkerGroup(id: string) {
  return api.post<WorkerGroupDetail>(`/worker-groups/${id}/refresh`);
}
